import { combineReducers } from '@reduxjs/toolkit';
import profileSettingsReducer from './Pages/ProfileSettings/profileSettingsReducer';
import subscriptionsReducer from './Pages/Subscriptions/subsriptionsSlice';
import basicMembersReducer from './membersDashboardSlice';
import websiteEditingReducer from './Pages/WebsiteEditing/websiteEditingSlice';

export const membersDashboardReducer = combineReducers({
  basic: basicMembersReducer,
  editing: websiteEditingReducer,
  profile: profileSettingsReducer,
  subscriptions: subscriptionsReducer,
});

export default membersDashboardReducer;
